var _rect, _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColaboratedProjects(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0938 28.7822C13.0938 29.1425 13.353 29.4271 13.6779 29.4271H19.1587V28.1409H13.6779C13.353 28.1445 13.0938 28.4291 13.0938 28.7822Z",
    fill: "#FEC98C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4456 28.1444H22.9648V29.4307H28.4456C28.7705 29.4307 29.0298 29.146 29.0298 28.7857C29.0298 28.429 28.7705 28.1444 28.4456 28.1444Z",
    fill: "#FEC98C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.633 27.5753H19.4922V30.0001H22.633V27.5753Z",
    fill: "#FEC98C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1318 14.464H10.0791C9.89528 14.464 9.72791 14.5577 9.61632 14.7198C9.50474 14.8819 9.47192 15.0873 9.52443 15.2747L12.0843 25.0063C12.1532 25.2765 12.383 25.4674 12.6422 25.4674H20.4827V27.2041H21.651V25.4674H29.9247C30.0461 25.4674 30.1577 25.4314 30.2529 25.3629L27.6864 14.9072C27.6077 14.6477 27.3845 14.464 27.1318 14.464Z",
    fill: "#FEC98C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.92 10H22.9066C22.7228 10 22.5554 10.0901 22.4471 10.245L21.2493 11.924C21.072 12.169 20.8095 12.3131 20.5305 12.3131H12.0731C11.7515 12.3131 11.4922 12.5977 11.4922 12.9508V14.1002H27.1304C27.5341 14.1002 27.8852 14.3848 28.0001 14.8064L30.4911 24.9523C30.4976 24.9127 30.5009 24.873 30.5009 24.8298V10.6413C30.5009 10.2882 30.2416 10 29.92 10Z",
    fill: "#FEC98C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColaboratedProjects);
export default __webpack_public_path__ + "static/media/colaboratedProjects.827fdebe7f9ea6c209e267a0e1b5cc20.svg";
export { ForwardRef as ReactComponent };